<template>
  <div
    v-if="appendToBody === false || had === 0"
    class="pricelistbox voguePriceList"
    :class="{
      reverse: type === 'reverse',
      voguePriceList: model == 'vogue',
      athenaPricelist: nav_bottom && model == 'vogue',
      collapsible_itme_bottom: collapsible_itme_bottom && model == 'vogue',
      otherlist:$store.state.theme_name !== 'athena' && $store.state.theme_name !== 'vogue',
      'vogue-box':$store.state.theme_name == 'vogue',
      keepRight: keepRight,
    }"
  >
    <div class="vogue-icon" :style="{ 'border-top': '12px solid '+ back_color + '!important' }"></div>
    <ul
      class="pricelist"
      :style="{ background: back_color + '!important' }"
      
      ref="pricelist"
      @click.prevent="clickpricelist"
    >
      <li
        v-if="
          $store.state.rates[$store.state.currentcountry] && model !== 'vogue'
        "
        style="text-transform: capitalize"
        class="clearfix"
      >
        <div 
          class="iconfont-cy-rd icon-cy-rd-zidong vogue_li"
          :style="{fontSize:$store.state.theme_name == 'vogue'?'30px':'20px'}"></div>
        <span class="secondary_title">Auto</span>
        <!-- <span class="iconfont icon-check" style="float:right"></span> -->
      </li>
      <template v-for="(item,index) in countryList">
        <li
          class="clearfix"
          v-if="$store.state.rates[item]"
          :class="{model,otherlist_li:index==0}"
          :key="item"
        >
          <div
            :class="`iconfont-cy-rd icon-cy-rd-${item} ${$store.state.theme_name !== 'athena'?'vogue_li':''} `"
            :style="{fontSize: $store.state.theme_name == 'vogue'?'30px':'20px',}"
            v-if="$store.state.theme_name !== 'athena'"
          ></div>
          <div v-else :class="`iconfont-cy icon-cy-${item}`"></div>
          <span
            class="secondary_title"
            :class="{
              bold: $store.state.pricetype == item,
              menu_icon_color: model == 'vogue',
            }"
          >{{ item }}</span>
          <i
            v-if="collapsible_itme_bottom && $store.state.pricetype == item"
            class="iconfont icon-check"
            style="float: right"
          ></i>
        </li>
      </template>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: [String],
    },
    appendToBody: {
      type: [Boolean],
    },
    keepRight: {
      type: [Boolean],
    },
    model: {
      type: [String],
    },
    nav_bottom: {
      type: [Boolean],
    },
    collapsible_itme_bottom: {
      type: [Boolean],
    },
    back_color: "",
  },
  data() {
    return {
      active: this.$store.state.pricetype,
      had: 0,
      countryList: [
        "AUD",
        "CAD",
        "CNY",
        "EUR",
        "GBP",
        "JPY",
        "NZD",
        "USD",
        "MXN",
        "INR",
        "ARS",//阿根廷比索
        "UYU",//乌拉圭比索
        "BRL",//巴西雷亚尔
        "RUB",//俄罗斯
        "KRW",//韩国
      ],
    };
  },
  methods: {
    clickpricelist(e) {
      if (e.target.parentNode.tagName == "LI") {
        // 判断如果是auto的话 存入自动获取的当前国家
        var pricetype =
          this.$(e.target.parentNode).find("span").text() == "Auto"
            ? this.$store.state.currentcountry
            : this.$(e.target.parentNode).find("span").text().trim();
        localStorage.setItem("pricetype", pricetype);
        this.$store.dispatch("changepricetype", pricetype);
      } else if (e.target.tagName == "LI") {
        var pricetype =
          this.$(e.target).find("span").text() == "Auto"
            ? this.$store.state.currentcountry
            : this.$(e.target).find("span").text().trim();
        localStorage.setItem("pricetype", pricetype);
        this.$store.dispatch("changepricetype", pricetype);
      }
    },
  },
  mounted() {
    this.had = this.$("body>.pricelistbox").length;
    if (this.appendToBody !== false) {
      document.body.appendChild(this.$el);
    }
  },
};
</script>
<style scoped lang='scss'>
.keepRight{
  right: 0;
}
.reverse {
  transform: rotateX(180deg);
  transform-origin: center -17px;
  li {
    border-top: 1px solid #d8d8d8;
    border-bottom: none !important;
    transform: rotateX(180deg);
  }
}
.pricelistbox {
  width: 90px;
  position: absolute;
  z-index: 40;
  white-space: normal;

  .pricelist {
    border: 1px solid rgb(240, 240, 240);
    padding: 2px;
    position: absolute;
    background: white;
    display: none;
    z-index: 999999;
    top: 25px;
    left: 0;
    text-align: left;

    li {
      font-size: 13px;
      text-align: left;
      padding: 2px;
      color: black;
      border-bottom: 1px solid #d8d8d8;
      list-style: none;
      cursor: pointer;

      .bold {
        font-weight: bold !important;
      }
      span {
        vertical-align: middle;
        padding-right: 5px;
        font-weight: normal !important;
      }
      .iconfont-cy {
        font-size: 40px;
      }
    }

    li:first-child {
      padding-top: 0;
    }
    li:last-child {
      border: none;
    }

    li:hover {
      background: rgb(51, 51, 51);
      color: white;
    }
  }
}
.vogue_li{
  // display: inline-flex !important;
  // align-items: center;
  display: inline-block;
  margin-right: 5px;
  padding: 0 !important;
  vertical-align: middle;
}
.otherlist{
  width: 160px !important;
  .pricelist{
    padding: 16px 0px 4px 20px !important;
    padding-bottom: 0 !important;
    top: 10px !important;
    li{
      max-width: 78px !important;
      display: inline-flex !important;
      line-height: 20px !important;
      margin-bottom: 16px !important;
      font-weight: normal;
      margin-right: 5px !important;
    }
    .otherlist_li{
      margin-left: -4px;
    }
  }
}
.vogue-box {
  margin-left: -28px;
  .vogue-icon {
    position: absolute;
    top: 14px;
    z-index: 1000000;
    // 层级高于.pricelist
    left:30px;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-top: 12px solid #fff;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.12));
    transform: rotate(180deg);
  }
}
.voguePriceList {
  width: 230px;
  
  .pricelist {
    border: none;
    padding: 10px 15px;
    //padding-top: 10px;
    margin-bottom: 0;
    margin-right: -30px;
    overflow: hidden;
    box-shadow: 0 8px 30px rgb(0 0 0 / 10%);
    li {
      padding: 0;
      border: none;
      display: inline-block;
      &:hover {
        background: inherit;
        color: inherit;
      }
      &:nth-child(odd) {
        width: 50%;
        margin-right: 10px;
      }
      // &:nth-child(even) {
      //   float: right;
      //   text-align: right;
      //   span {
      //     padding-right: 0;
      //   }
      // }
    }
    li:not(:last-child) {
      margin-bottom: 20px;
    }
  }
}
.athenaPricelist {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 1px;
  .pricelist {
    width: 100%;
    display: none;
    padding: 0 52px;
    align-items: center;
    min-height: 120px;
    background: #f5f5f7;
    flex-wrap: wrap;
    top: 0;
    li {
      width: unset !important;
      margin: 0 !important;
      //flex: 1;
      text-align: center;
      padding: 16px 30px 0px !important;
      height: 120px;
      .currencyCountry {
        display: block;
        margin: 0 auto !important;
      }
      .currencyCountry.vogue {
        width: 64px;
        background-size: 1024px 900px;
        margin-right: 5px;
        height: 44px;
        &.AUTO {
          background-position: 0px -643px;
        }
        &.AUD {
          background-position: -512px -9px;
        }
        &.CAD {
          background-position: -256px -129px;
        }
        &.CNY {
          background-position: -704px -129px;
        }
        &.EUR {
          background-position: -128px -249px;
        }
        &.GBP {
          background-position: -576px -249px;
        }
        &.JPY {
          background-position: -256px -368.5px;
        }
        &.NZD {
          background-position: -256px -548px;
        }
        &.USD {
          background-position: -256px -728px;
        }
        &.INR {
          background-position: -768px -307.5px;
        }
        &.MXN {
          background-position: -448px -487.5px;
        }
      }
      & > span {
        padding: 0 !important;
        font-size: 14px;
      }
    }
  }
}
.collapsible_itme_bottom {
  width: 100%;
  .pricelist {
    width: 100%;
    box-shadow: unset !important;
    position: unset !important;
    display: none;
    li {
      width: 100% !important;
      margin: 0 !important;
    }
  }
}

@media screen and (max-width: 767px){
  .vogue_box {
    margin-left: unset;
  }
}
</style>